import React, {useState} from 'react';
import styles from './FAQSection.module.css';
import FAQCard from "./FAQCard";
import {useTranslation} from "react-i18next";

export interface FAQItem {
    question: string;
    answer: string;
}

const FAQSection: React.FC = () => {
    const {t} = useTranslation();

    const faqs: FAQItem[] = [
        {question: t('faq_1'), answer: t('faq_1_ans')},
        {question: t('faq_2'), answer: t('faq_2_ans')},
        {question: t('faq_3'), answer: t('faq_3_ans')},
        {question: t('faq_4'), answer: t('faq_4_ans')},
        {question: t('faq_5'), answer: t('faq_5_ans')},
        {question: t('faq_6'), answer: t('faq_6_ans')},
        {question: t('faq_7'), answer: t('faq_7_ans')}
    ];

    return (
        <section className={styles.faqSection}>
            <p className={styles.title}>{t('faq')}</p>
            <div className={styles.faqList}>
                {faqs.map((faq, index) => (
                    <FAQCard key={index} question={faq.question} answer={faq.answer}/>
                ))}
            </div>
        </section>
    );
};

export default FAQSection;

